import { skipToken } from "@reduxjs/toolkit/query";

import { useLendVaultActivityQuery } from "../../reducers/lendingVaultsPublicApi";
import { LendVaultActivityResponse } from "../../types";
import { LendVaultActivityRequestApi } from "../../types/api/lend-vault-activity";

export function useLendVaultActivityDomain(params: LendVaultActivityRequestApi | undefined): {
    data: LendVaultActivityResponse | undefined;
    isLoading: boolean;
    isFetching: boolean;
} {
    const query = useLendVaultActivityQuery(params ? params : skipToken);
    return {
        data: query.data,
        isLoading: query.isLoading,
        isFetching: query.isFetching
    };
}
